import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { TextField } from '@mui/material';
import Stack from '@mui/material/Stack';
import { useCreatePost } from '../../../hooks/history/useCreatePost';
import { useUpdatePost } from '../../../hooks/history/useUpdatePost';
import { useSnackbar } from '../../../context/SnackbarContext';
import { useTranslation } from 'react-i18next';

export default function PostForm({ successCallback = null, history = null, historyEntry = null, post = null, mode = "create", open, onClose }) {

    const { t } = useTranslation('common'); 

    const [message, setMessage] = React.useState(post ? post.message : "");

    const { create } = useCreatePost(successCallback);
    const { update } = useUpdatePost(successCallback);

    const { showSnackbar } = useSnackbar();

    React.useEffect(() => {
        // reset field when there are changes (e.g. when opening edit)
        setMessage(post ? post.message : "");
    }, [post, open]);

    const handleSave = async () => {
        if (!message.trim()) {
            showSnackbar(t('posts.messages.content_required'), "warning");
            return;
        }

        try 
        {
            if (mode === "create") {
                await create({ 
                    history_id: history ? history.id : null,
                    history_entry_id: historyEntry ? historyEntry.id : null,
                    message: message,
                });
                showSnackbar(t('posts.messages.create_success'), "success");
            } else if (mode === "edit" && post) {
                await update(post.id, { 
                    message: message,
                });
                showSnackbar(t('posts.messages.update_success'), "success");
            }
            setMessage("");   // clear field after save
            onClose();     // close dialog
        } catch (err) {
            showSnackbar(t('posts.messages.save_fail'), "error");
        }
    };

    const handleCancel = () => {
        setMessage("");   // clear field on cancel
        onClose();
    };

    return (
        <>
        <Dialog onClose={handleCancel} open={open} disableRestoreFocus>

        <DialogTitle>{mode === "create" ? "Add Note" : "Edit Note"}</DialogTitle>

        <DialogContent dividers>
            <Stack spacing={1}>
            <TextField
                autoFocus
                label="Note"
                variant="outlined"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                fullWidth
                multiline
                minRows={3}
                maxRows={5}
            />
            </Stack>
        </DialogContent>

        <DialogActions>
            <Button onClick={handleSave}>
                Save
            </Button>
            <Button onClick={handleCancel}>Cancel</Button>
        </DialogActions>
        </Dialog>
        </>
    );
}